const createTimer = ( updateTime ) => {

  let timer;
  let isStart = false;
  let startedTime = 0;
  let currentTime = 0;
  let totalTime = 0;

  const start = () => {
    if ( ! isStart ) {
      isStart = true;
      startedTime = Date.now();
      clearInterval( timer );
      timer = setInterval( update );
    }
  };

  const update = () => {
    currentTime = Math.abs( startedTime - Date.now() );
    updateTime( totalTime + currentTime );
  };

  const pause = () => {
    if ( isStart ) {
      isStart = false;
      clearInterval( timer );
      totalTime += currentTime;
    }
  };

  const clear = () => {
    pause();
    totalTime = 0;
  };

  return {
    start,
    pause,
    clear
  };

};

export default createTimer;
